let defaultBaseUrl = ''
let shdHost = ''

if (process.env.NODE_ENV === 'production') {
  defaultBaseUrl = '/prod-api'
  shdHost = '/erp'
} else {
  // defaultBaseUrl = 'http://192.168.3.48:8081'
   defaultBaseUrl = 'https://im.61xm.cn/prod-api'
  //defaultBaseUrl = 'https://testim.61xm.cn/prod-api'
  // shdHost = 'http://erp.61xm.cn'
}

export default {
  defaultBaseUrl,
  shdHost,
  ak: 'zhangchuanbeizhu',
}